import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of,catchError } from 'rxjs';
 import { Emicalculation, EmicalculationMaintanence } from './emicalculation.model';
import { environment } from 'src/environments/environment';
@Injectable()
export class EmicalculationService implements BaseFpxDataService<any> {
 constructor(private _httpProvider : HttpProviderService) { }
  create(payload: Emicalculation): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/emicalculation');
      let bodyContent = {"emicalculation":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }
 
  findByKey(key: Emicalculation): FindByKeyFn<Emicalculation|null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/emicalculation/{emiAmount}');
       httpRequest.addPathParameter('emiAmount', key.emiAmount);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.emicalculation ?? null),catchError((err:any) => {
              return of(null)
            }));
        
    };
  }

  modify(payload: Emicalculation): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/emicalculation/{emiAmount}');
       httpRequest.addPathParameter('emiAmount', payload.emiAmount);
     httpRequest.setMethod('PUT');
      let bodyContent = {"emicalculation":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }
  
  
 findAll(criteriaQuery: CriteriaQuery): FindAllFn<Emicalculation[]> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/emicalculation');
      httpRequest.setMethod('GET');
      httpRequest.setCriteriaQuery(criteriaQuery);
      httpRequest.setServerContext(environment.loansPublisher);
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(
          map(
            (res: IHttpSuccessPayload<EmicalculationMaintanence>) =>
              res.body.emicalculation
          )
        );
    };
  }
  
   
     lookup(key: any): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      httpRequest.setResource('/emicalculation');
      httpRequest.addQueryParameter('lookup', 1);
      const httpCriteria = new CriteriaQuery();
	  httpCriteria.setPaginationCriteria('1', 10);
	  httpCriteria.addFilterCritertia('text', 'String', 'startsWith', {
	  searchText: key.searchText ?? '',
	  });
	  httpRequest.setCriteriaQuery(httpCriteria);
    httpRequest.setServerContext(environment.loansPublisher);
      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }
   FetchDetails(): Observable<any> {
    
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/emicalculation');
      httpRequest.setMethod('GET');
      //httpRequest.setCriteriaQuery(criteriaQuery);
      httpRequest.setServerContext(environment.loansPublisher);
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(
          map(
            (res: IHttpSuccessPayload<any>) =>
              res.body.emicalculation
          )
        );

  }
    
}
